var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PdfConvert',{attrs:{"back_as_landing_page":true,"rotta_back":'/home/electrical'}})}
var staticRenderFns = []

export { render, staticRenderFns }